import { signal } from "@preact/signals";
import type { IconName } from "../api/types.gen.ts";
import { negotiate } from "../i18n/index.ts";
import { lazy } from "./lazy.ts";
import { fold } from "./text.ts";

/** Search words per icon and language (`iconKeywords.json`): what it shows and what people might file under it. */
type Keywords = Record<string, Partial<Record<string, readonly string[]>>>;

const SPACES = /\s+/u;

const keywords = signal<Keywords | null>(null);

/** Starts loading the search words (once; the picker asks when it opens). */
export const loadKeywords: () => Promise<void> = lazy(() =>
  import("./iconKeywords.json").then((m) => {
    keywords.value = m.default as Keywords;
  }),
);

/**
 * Whether icon `name` matches query `q`: every word of it (accents and case aside) appears in the name or the
 * icon's words in `lang` or English.
 */
export function matches(name: IconName, q: string, lang: string): boolean {
  const words = fold(q).split(SPACES).filter(Boolean);
  if (words.length === 0) {
    return true;
  }
  const kw = keywords.value?.[name];
  const own = kw?.[lang] ?? kw?.[negotiate([lang])] ?? []; // "it-IT" → the "it" words
  const hay = fold([name.replaceAll("-", " "), ...own, ...(kw?.["en"] ?? [])].join(" "));
  return words.every((w) => hay.includes(w));
}
